<div class="multiple_select_checkbox">
  <div id="multiple_select_checkbox_choice"><input type="checkbox" name="slt_username" value="1001" />Siva</div>
  <div id="multiple_select_checkbox_choice"><input type="checkbox" name="slt_username" value="1002" />Raja</div>
  <div id="multiple_select_checkbox_choice"><input type="checkbox" name="slt_username" value="1003" />Kumar</div>
  <div id="multiple_select_checkbox_choice"><input type="checkbox" name="slt_username" value="1004" />Vijay</div>
</div>

<br />
<button (click)="validate()">Validate</button>